import { type BannerResponse } from '@/pages/home/ui/bannerSliderSection/model/types/banner';

export const useMainSlider = async () => {
  const { $bannersService } = useNuxtApp();
  const banners = ref<BannerResponse[]>([]);

  const { data } = await useAsyncData('banners', async () => {
    return await $bannersService.getBanners();
  });

  banners.value = data.value?.data || [];

  return {
    banners,
  };
};
